import apiFetch from '@scale/frontend-lib/api-fetch';
import { VellumProductsResponse } from '@scale/shared/types/vellum';
import EnrichedError from 'react-scale/lib/enrichedError';

export class VellumCommunicationService {
  static fetchVellumProducts = async (): Promise<VellumProductsResponse> => {
    const url = '/internal/vellum/products';
    try {
      return await apiFetch<VellumProductsResponse>(null, url, {
        method: 'GET',
      });
    } catch (e) {
      throw new EnrichedError(
        e.status,
        "Couldn't fetch Vellum products.",
        e.response?.message ?? e.toString(),
        'Error fetching Vellum products from API.',
        url,
      );
    }
  };
}
